import { render, staticRenderFns } from "./RenameModal.vue?vue&type=template&id=7aaff35b&scoped=true"
import script from "./RenameModal.vue?vue&type=script&lang=js"
export * from "./RenameModal.vue?vue&type=script&lang=js"
import style0 from "./RenameModal.vue?vue&type=style&index=0&id=7aaff35b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaff35b",
  null
  
)

export default component.exports